/* eslint-disable import/no-anonymous-default-export */
export default (received = [], action) => {
  switch (action.type) {
    case "ALL_LOCATION_RECEIVED":
      return action.payload;
    case "UPDATE_RECEIPT":
      return received.filter((data) => data._id !== action.payload);
    default:
      return received;
  }
};
